import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import isEmpty from 'lodash/isEmpty';
import Select from 'ati-ui-react/components/AtiSelect';

import { useStores } from 'hooks/useStores';
import workingHoursTypes from 'utils/WorkingHoursTypes';
import setUrlParam from 'utils/setUrlParam';

import sortDates from './sortDates';

const defaultValue = {
  label: 'По времени публикации',
  value: 'by_time_of_publication',
};

const DateOfAnnouncement: FC = observer(() => {
  const {
    findTrucksStore: {
      fields: { advert_item_type, ordering },
      updateSelect,
      getTrucksResults,
    },
  } = useStores();

  const specialMachineryTypes = new Set(
    workingHoursTypes.map((element) => {
      return element.value;
    }),
  );

  const renderSortDates = () => {
    const specialMachineryTypesDates = sortDates.filter((item) => item.value !== 'mileage');
    const generalTypesDates = sortDates.filter((item) => item.value !== 'working_hours');

    if (isEmpty(advert_item_type) || advert_item_type === 'all_types_trucks') {
      return sortDates;
    }

    if (specialMachineryTypes.has(advert_item_type)) {
      return specialMachineryTypesDates;
    }

    return generalTypesDates;
  };

  return (
    <Select
      value={ordering || defaultValue}
      options={renderSortDates()}
      onChange={(value: { value: string }) => {
        updateSelect({ field: 'ordering', value: value?.value });
        setUrlParam({ field: 'ordering', value: value?.value });
        getTrucksResults();
      }}
      clearable={false}
      searchable={false}
    />
  );
});

export default DateOfAnnouncement;
